// extracted by mini-css-extract-plugin
export default {"main_column":"Page404_main_column__XfqZz","main":"Page404_main__Gf5ES","header_404":"Page404_header_404__TE6uz","to_main_button":"Page404_to_main_button__yZOX0"};